/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JurisdictionSchemeModel } from './JurisdictionSchemeModel';
import {
    JurisdictionSchemeModelFromJSON,
    JurisdictionSchemeModelFromJSONTyped,
    JurisdictionSchemeModelToJSON,
} from './JurisdictionSchemeModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfJurisdictionSchemeModel
 */
export interface ResultOfListOfJurisdictionSchemeModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfJurisdictionSchemeModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfJurisdictionSchemeModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfJurisdictionSchemeModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfJurisdictionSchemeModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfJurisdictionSchemeModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfJurisdictionSchemeModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfJurisdictionSchemeModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<JurisdictionSchemeModel>}
     * @memberof ResultOfListOfJurisdictionSchemeModel
     */
    data?: Array<JurisdictionSchemeModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfJurisdictionSchemeModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfJurisdictionSchemeModel interface.
 */
export function instanceOfResultOfListOfJurisdictionSchemeModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfJurisdictionSchemeModelFromJSON(json: any): ResultOfListOfJurisdictionSchemeModel {
    return ResultOfListOfJurisdictionSchemeModelFromJSONTyped(json, false);
}

export function ResultOfListOfJurisdictionSchemeModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfJurisdictionSchemeModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(JurisdictionSchemeModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfJurisdictionSchemeModelToJSON(value?: ResultOfListOfJurisdictionSchemeModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JurisdictionSchemeModelToJSON)),
        'Count': value.count,
    };
}

